import {Injectable} from "@angular/core";
import {UpgradeModule} from "@angular/upgrade/static";
import {from, Observable} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  authentication;

  constructor(private upgrade: UpgradeModule) {
    this.authentication = upgrade.injector.get("authentication");
  }

  public getKeyCode(): string {
    if (this.userIsLoaded()) {
      return this.authentication.getCurrentUser().keycode;
    } else {
      return this.getToken().keycode;
    }
  }

  public getSchools(): any {
    const userLoaded = this.authentication.getCurrentUser();
    if (userLoaded) {
      return this.authentication.getSchools();
    } else {
      return this.getToken().schools;
    }
  }

  public hasPathwayRequirementEditRole(): boolean {
    return this.authentication.hasPathwayRequirementEditRole();
  }

  public logout(): void {
    this.authentication.logout();
    this.authentication.clear();
    localStorage.setItem("X-API-TOKEN", null);
  }

  public isAuthenticated(): boolean {
    return this.authentication.isAuthenticated();
  }

  public refreshKeycode(): Observable<string> {
      return from(this.authentication.refreshKeycode(this.authentication.getCurrentUser().keycode))
          .pipe(map(({data: {_keycode}}) => _keycode));
  }

  private getToken(): any {
    return JSON.parse(JSON.parse(localStorage.getItem("X-API-TOKEN")));
  }

  private userIsLoaded(): boolean {
    return !!this.authentication.getCurrentUser();
  }

}
